.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.full {
  grid-column: 1 / -1;
}

.alert {
  grid-column: 1 / -1;
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  border: 1px solid color-mix(in srgb, var(--color-danger) 24%, transparent);
  border-radius: var(--radius-input);
  background-color: var(--color-danger-subtle);
  color: var(--color-danger-text);
  font-size: var(--text-sm);
  line-height: var(--leading-snug);
}

.alertIcon {
  flex: none;
  width: 17px;
  height: 17px;
  margin-top: 1px;
}

@media (max-width: 560px) {
  .grid {
    grid-template-columns: 1fr;
    gap: 9px;
  }
}
